import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { useHistory, useParams } from 'react-router-dom'
import { produce } from 'immer'
import { showTotast } from '../../../utils/toast'
import * as constants from '../../../utils/constants'
import { validationError } from '../../../utils/errorMessages'
import fileNumberSequenceService from '../../../services/systemConfiguration/fileNumberSequence/fileNumberSequenceService'
import { FileNumberSequenceModel } from '../../../models/systemConfiguration/fileNumberSequence/fileNumberSequenceModel'

const ModifyFileNumberSequence = () => {
  const history = useHistory()
  const { id } = useParams() as any
  const [model, setModel] = useState({} as FileNumberSequenceModel)

  useEffect(() => {
    async function load() {
      const resp = await fileNumberSequenceService.apiGetById(parseInt(id))
      setModel(resp.data)
    }
    load()
  }, [id])

  const isValid = () => {
    return !!(
      model.scheme &&
      model.scheme.trim() &&
      (model.districtNumber ?? 0) > 0 &&
      (model.schemeMaxNumber ?? 0) >= 0 &&
      (model.districtMaxNumber ?? 0) >= 0 &&
      (model.fileNumberMaxNumber ?? 0) >= 0
    )
  }

  const buttonClickSubmit = () => {
    if (!isValid()) {
      showTotast(
        constants.ALERT_WARNING,
        validationError,
        constants.TOAST_POSITION_TOP_RIGHT,
        5,
        constants.TOAST_TRANSITION_SLIDE
      )
      return
    }
    handleConfirm()
  }

  const handleConfirm = async () => {
    const payload: FileNumberSequenceModel = {
      scheme: model.scheme?.trim() || '',
      districtNumber: model.districtNumber ?? 0,
      schemeMaxNumber: model.schemeMaxNumber ?? 0,
      districtMaxNumber: model.districtMaxNumber ?? 0,
      fileNumberMaxNumber: model.fileNumberMaxNumber ?? 0,
    }
    const result = await fileNumberSequenceService.apiModify(
      Number.parseInt(id),
      payload
    )
    const success = result.status === 200
    showTotast(
      success ? constants.ALERT_SUCCESS : constants.ALERT_WARNING,
      success
        ? 'File number sequence updated.'
        : result.errorMessage || validationError,
      constants.TOAST_POSITION_TOP_RIGHT,
      5,
      constants.TOAST_TRANSITION_SLIDE
    )
    if (success) history.goBack()
  }

  return (
    <>
      <Row className="title-layout">
        <Col className="d-flex justify-content-start">
          <span className="m-2">File Number Sequence</span>
        </Col>
      </Row>

      <Row className="create-user-page-layout">
        <Col sm={12} className="border-label">
          <div className="border-label-span">Modify File Number Sequence</div>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Scheme</Form.Label>
              <Form.Control
                placeholder="Scheme"
                value={model.scheme || ''}
                onChange={(e) => {
                  setModel(
                    produce(model, (draft) => {
                      draft.scheme = e.target.value
                    })
                  )
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>District Number</Form.Label>
              <Form.Control
                type="number"
                placeholder="District Number"
                value={model.districtNumber ? model.districtNumber : ''}
                onChange={(e) => {
                  setModel(
                    produce(model, (draft) => {
                      draft.districtNumber = parseInt(e.target.value || '0')
                    })
                  )
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Scheme Max Number</Form.Label>
              <Form.Control
                type="number"
                placeholder="Scheme Max Number"
                value={model.schemeMaxNumber ? model.schemeMaxNumber : ''}
                onChange={(e) => {
                  setModel(
                    produce(model, (draft) => {
                      draft.schemeMaxNumber = parseInt(e.target.value || '0')
                    })
                  )
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>District Max Number</Form.Label>
              <Form.Control
                type="number"
                placeholder="District Max Number"
                value={model.districtMaxNumber ? model.districtMaxNumber : ''}
                onChange={(e) => {
                  setModel(
                    produce(model, (draft) => {
                      draft.districtMaxNumber = parseInt(e.target.value || '0')
                    })
                  )
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>File Number Max</Form.Label>
              <Form.Control
                type="number"
                placeholder="File Number Max"
                value={
                  model.fileNumberMaxNumber ? model.fileNumberMaxNumber : ''
                }
                onChange={(e) => {
                  setModel(
                    produce(model, (draft) => {
                      draft.fileNumberMaxNumber = parseInt(
                        e.target.value || '0'
                      )
                    })
                  )
                }}
              />
            </Form.Group>

            <Row>
              <Col className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={buttonClickSubmit}
                >
                  Save
                </button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </>
  )
}

export default ModifyFileNumberSequence
